export interface IKlineListItem {
  text: string;
  interval: string;
  type: keyof typeof TimeBenchType;
  sort: number;
  title: string;
  selected?: boolean;
}

/**
 * 这里写成一个普通的map也是可以的
 */
export enum TimeBenchType {
  "M" = "kline_interval.u220224_kline_minute_title",
  "H" = "kline_interval.u220224_kline_hour_title",
  "D" = "kline_interval.u220224_kline_day_title",
}

export const CurrentKlinePeriodVersion = "0.0.2";

export const DefaultTimePanelList: Array<IKlineListItem> = [
  {
    title: "kline_interval.market_text_timeline",
    text: "RealTime",
    interval: "1m",
    type: "M",
    sort: -1,
  },
  {
    title: "kline_interval.market_text_15",
    text: "15M",
    interval: "15m",
    type: "M",
    sort: 4,
  },
  {
    title: "kline_interval.market_text_1hour",
    text: "1H",
    interval: "1H",
    type: "H",
    sort: 10,
  },
  {
    title: "kline_interval.market_text_4hour",
    text: "4H",
    interval: "4H",
    type: "H",
    sort: 12,
  },
  {
    title: "kline_interval.text_one_day",
    text: "1D",
    interval: "1Dutc",
    type: "D",
    sort: 20,
  },
];

export const TimePanelList: Array<IKlineListItem> = [
  {
    title: "kline_interval.market_text_timeline",
    text: "RealTime",
    interval: "1m",
    type: "M",
    sort: -1,
  },
  {
    title: "kline_interval.market_text_1time",
    text: "1M",
    interval: "1m",
    type: "M",
    sort: 0,
  },
  {
    title: "kline_interval.u220225_market_text_2min",
    text: "2M",
    interval: "2m",
    type: "M",
    sort: 1,
  },
  {
    title: "kline_interval.u220225_market_text_3min",
    text: "3M",
    interval: "3m",
    type: "M",
    sort: 2,
  },
  {
    title: "kline_interval.market_text_5time",
    text: "5M",
    interval: "5m",
    type: "M",
    sort: 3,
  },
  {
    title: "kline_interval.market_text_15",
    text: "15M",
    interval: "15m",
    type: "M",
    sort: 4,
  },
  {
    title: "kline_interval.market_text_30time",
    text: "30M",
    interval: "30m",
    type: "M",
    sort: 5,
  },
  {
    title: "kline_interval.market_text_1hour",
    text: "1H",
    interval: "1H",
    type: "H",
    sort: 10,
  },
  {
    title: "kline_interval.market_text_2hour",
    text: "2H",
    interval: "2H",
    type: "H",
    sort: 11,
  },
  {
    title: "kline_interval.market_text_4hour",
    text: "4H",
    interval: "4H",
    type: "H",
    sort: 12,
  },
  {
    title: "kline_interval.market_text_6hour",
    text: "6H",
    interval: "6Hutc",
    type: "H",
    sort: 13,
  },
  {
    title: "kline_interval.u220225_market_text_8hour",
    text: "8H",
    interval: "8H",
    type: "H",
    sort: 14,
  },
  {
    title: "kline_interval.u220225_market_text_12hour",
    text: "12H",
    interval: "12Hutc",
    type: "H",
    sort: 15,
  },
  {
    title: "kline_interval.text_one_day",
    text: "1D",
    interval: "1Dutc",
    type: "D",
    sort: 20,
  },
  {
    title: "kline_interval.u220225_market_text_3day",
    text: "3D",
    interval: "3Dutc",
    type: "D",
    sort: 21,
  },
  {
    title: "kline_interval.market_text_1week",
    text: "1W",
    interval: "1Wutc",
    type: "D",
    sort: 22,
  },
  {
    title: "kline_interval.u220225_market_text_monthline",
    text: "1M",
    interval: "1Mutc",
    type: "D",
    sort: 23,
  },
  {
    title: "kline_interval.u220225_market_text_3monthline",
    text: "3M",
    interval: "3Mutc",
    type: "D",
    sort: 24,
  },
];

// 多图 布局使用
export interface ILayoutListItem {
  value: string;
  type: keyof typeof LayoutType;
  icon: any;
}
export enum LayoutType {
  "one" = "1",
  "two" = "2",
  "tree" = "3",
  "four" = "4",
}

export const LayoutList: Array<ILayoutListItem> = [
  {
    value: "s",
    type: "one",
    icon: "icon-a-xingzhuang2",
  },
  {
    value: "2h",
    type: "two",
    icon: "icon-a-xingzhuang12",
  },
  {
    value: "2v",
    type: "two",
    icon: "icon-a-xingzhuang6",
  },
  // 3图
  {
    value: "3v",
    type: "tree",
    icon: "icon-a-xingzhuang7",
  },
  {
    value: "3h",
    type: "tree",
    icon: "icon-a-xingzhuang10",
  },
  // 左1 右2
  {
    value: "3s",
    type: "tree",
    icon: "icon-a-xingzhuang3",
  },
  // 上2 下1
  {
    value: "2-1",
    type: "tree",
    icon: "icon-xingzhuangbeifen",
  },
  // 上1 下2
  {
    value: "1-2",
    type: "tree",
    icon: "icon-a-xingzhuangbeifen2",
  },
  // 左2 右1
  {
    value: "3r",
    type: "tree",
    icon: "icon-a-xingzhuangbeifen3",
  },

  // 4图    4格均分
  {
    value: "4",
    type: "four",
    icon: "icon-a-xingzhuang4",
  },
  // 竖
  {
    value: "4h",
    type: "four",
    icon: "icon-a-xingzhuang11",
  },
  {
    value: "4v",
    type: "four",
    icon: "icon-a-xingzhuangbeifen4",
  },
  // 左1 右3
  {
    value: "4s",
    type: "four",
    icon: "icon-a-xingzhuang8",
  },
  // 上1 下3
  {
    value: "1-3",
    type: "four",
    icon: "icon-a-xingzhuang9",
  },
  // 上2 下2
  {
    value: "2-2",
    type: "four",
    icon: "icon-a-xingzhuang5",
  },
];

// 点击多图按钮，需要使用这个映射配置
export const layoutInfoMapConfig = {
  s: 1,
  "2h": 2,
  "2v": 2,

  "3v": 3,
  "3h": 3,
  "3s": 3,
  "2-1": 3,
  "1-2": 3,
  "3r": 3,

  "4": 4,
  "4h": 4,
  "4v": 4,
  "4s": 4,
  "1-3": 4,
  "2-2": 4,
};

export const scrollByDistanceVal = -450; // 找到对应的k线柱，距离屏幕的距离，为了让对应k线柱居中

// 禁用时间配置 （配置各k线周期， 最多可以在当前时间点， 向前选多少天， 这个时间点取决于，接口数据的最后一项）
export const getDisableConfig = () => {
  // 线上环境 每次请求300条数据 为例   200ms拿回300条数据，1秒拿回1500条数据   3秒拿4500条数据

  const baseMinuNum = 3; //  1分钟周期   每天需要1440条数据  可选近3天          3秒拿回数据 4320条
  const baseHourNum = 60; //  1小时周期  每天需要24条数据，  最近可选近60天      1秒拿回数据 1440条
  const baseDayNum = 1500; // 1天周期    每天需要1条数据 最近可选 1500天 4年     1秒拿回数据 1500条

  let disableDateConfig = {
    "1m": {
      num: baseMinuNum,
      current: null,
    },
    "2m": {
      num: baseMinuNum * 2,
      current: null,
    },
    "3m": {
      num: baseMinuNum * 3,
      current: null,
    },
    "5m": {
      num: baseMinuNum * 5,
      current: null,
    },
    "15m": {
      num: baseMinuNum * 15,
    },
    "30m": {
      num: baseMinuNum * 30,
      current: null,
    },
    "1H": {
      num: baseHourNum,
      current: null,
    },
    "2H": {
      num: baseHourNum * 2,
      current: null,
    },
    "4H": {
      num: baseHourNum * 4,
      current: null,
    },
    "6Hutc": {
      num: baseHourNum * 6,
      current: null,
    },
    "8H": {
      num: baseHourNum * 8,
      current: null,
    },
    "12Hutc": {
      num: baseHourNum * 12,
      current: null,
    },
    "1Dutc": {
      num: baseDayNum,
      current: null,
    },
    "3Dutc": {
      num: baseDayNum * 3,
      current: null,
    },
    "1Wutc": {
      num: baseDayNum * 7,
      current: null,
    },
    "1Mutc": {
      num: baseDayNum * 30,
      current: null,
    },
    "3Mutc": {
      num: baseDayNum * 30 * 3,
      current: null,
    },
  };
  return { disableDateConfig };
};

// Tradingview 将多语言进行转化
export const handleTvLang = (lang: string) => {
  let tvLocale = "en";
  switch (lang) {
    case "id":
      tvLocale = "id_ID";
      break;
    case "zh-CN":
      tvLocale = "zh";
      break;
    case "zh-TW":
      tvLocale = "zh_TW";
      break;
    case "en-GB":
      tvLocale = "en";
      break;
    case "en-ZA":
      tvLocale = "en";
      break;
    case "en-IN":
      tvLocale = "en";
      break;
    case "en-PH":
      tvLocale = "en";
      break;
    case "nl":
      tvLocale = "nl_NL";
      break;
    case "uk":
      tvLocale = "en";
      break;
    case "uz":
      tvLocale = "en";
      break;
    case "sk":
      tvLocale = "en";
      break;
    case "es-ES":
      tvLocale = "es";
      break;
    case "pt-PT":
      tvLocale = "pt";
      break;
  }
  return tvLocale;
};
